import React, { useRef } from 'react';
import cx from 'classnames';
import { TickIcon } from 'components/common';

type Props = {
  currentIndex: number;
  steps: {
    iconColor: string;
    icon: string;
    iconText: string;
    isExecuted: boolean;
  }[];
  className?: string;
  stepLength: number;
};

const StepProgressBar = ({
  currentIndex = 0,
  steps,
  stepLength,
  className
}: Props) => {
  const stepRef = useRef<HTMLDivElement>(null);
  const percentage = (currentIndex / stepLength) * 100;

  return (
    <div className={cx('w-full', className)} ref={stepRef}>
      <div className="relative flex justify-between before:absolute before:top-1/2 before:left-0 before:h-1 before:w-full before:bg-gray-200 before:content-[''] after:top-1/2 after:left-0 after:h-1">
        {steps.map((data, stepIndex) => (
          <div
            key={stepIndex}
            className={cx(
              'relative z-20 flex h-12 w-12 items-center justify-center rounded-full bg-gray-200 text-3xl sm:h-16 sm:w-16',
              { 'bg-primary': currentIndex === stepIndex },
              'text-white'
            )}
            style={{ backgroundColor: `#${data.iconColor}` }}
          >
            <img className="h-full w-full" src={data.icon} alt={`Step ${stepIndex + 1}`} />
            <div
              style={{ minWidth: '100px' }}
              className="absolute left-1/2 bottom-0 translate-x-[-50%] translate-y-full flex items-center justify-center text-sm sm:text-xl text-black"
            >
              {data.iconText}
            </div>

            {data.isExecuted && (
              <TickIcon className="absolute top-0 -right-2 text-3xl" />
            )}
          </div>
        ))}

        <div className="absolute left-12 right-12 top-1/2 -translate-y-1/2 sm:left-16 sm:right-16">
          <div
            className="absolute left-0 h-[3px] animate-pulse rounded-r-lg rounded-b-lg bg-black/75"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default StepProgressBar;
